import { useCallback, useContext, useState } from 'react';

import { ApolloClientContext } from 'src/data/ApolloClientContext';
import { Staff_AcceptPopInClinicRequestMutation as AcceptPopInClinicRequestMutation } from 'src/generated/gql/graphql';
import { ACCEPT_POP_IN_CLINIC_REQUEST_MUTATION } from 'src/myDayToday/hooks/useAcceptPopInClinicRequest.gql';

export type AcceptedPopInClinicRequest = NonNullable<
  AcceptPopInClinicRequestMutation['staff_acceptPopInClinicRequest']
>;

type AcceptPopInClinicRequest = () => Promise<AcceptedPopInClinicRequest | null>;

export function useAcceptPopInClinicRequest() {
  const { apolloClient } = useContext(ApolloClientContext);
  const [isLoading, setIsLoading] = useState(false);

  const acceptPopInClinicRequest = useCallback<AcceptPopInClinicRequest>(async () => {
    if (!apolloClient) {
      return null;
    }

    setIsLoading(true);
    try {
      const response = await apolloClient.mutate({
        mutation: ACCEPT_POP_IN_CLINIC_REQUEST_MUTATION,
      });

      return response.data?.staff_acceptPopInClinicRequest ?? null;
    } finally {
      setIsLoading(false);
    }
  }, [apolloClient]);

  return { acceptPopInClinicRequest, isLoading };
}
